var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.4,
    height: 16.4,
    viewBox: "0 0 16.4 16.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icona_impostazioni",
    "data-name": "icona impostazioni",
    transform: "translate(0.2 0.2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_19",
    "data-name": "Raggruppa 19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_19",
    "data-name": "Tracciato 19",
    d: "M8.747,16H7.253a1,1,0,0,1-.991-.88L6.1,13.869a6.3,6.3,0,0,1-.916-.379l-1,.774a.994.994,0,0,1-1.323-.084l-1.05-1.05a.992.992,0,0,1-.081-1.319l.774-1A6.155,6.155,0,0,1,2.131,9.9L.878,9.739A1,1,0,0,1,0,8.747V7.253a1,1,0,0,1,.88-.991L2.131,6.1a6.3,6.3,0,0,1,.379-.916l-.773-1A.994.994,0,0,1,1.822,2.86l1.05-1.05a.993.993,0,0,1,1.319-.081l1,.775A6.277,6.277,0,0,1,6.1,2.131L6.263.878A1,1,0,0,1,7.253,0H8.747a1,1,0,0,1,.991.88L9.9,2.131a6.277,6.277,0,0,1,.917.379l1-.774a.994.994,0,0,1,1.323.085l1.05,1.05a.992.992,0,0,1,.081,1.319l-.774,1a6.155,6.155,0,0,1,.379.916l1.253.159A1,1,0,0,1,16,7.253V8.747a1,1,0,0,1-.88.991L13.869,9.9a6.3,6.3,0,0,1-.379.916l.774,1a.993.993,0,0,1-.085,1.323l-1.05,1.05a.991.991,0,0,1-1.319.081l-1-.774a6.155,6.155,0,0,1-.916.379l-.159,1.253A1,1,0,0,1,8.747,16ZM5.153,12.76a.338.338,0,0,1,.163.042,5.6,5.6,0,0,0,1.183.491.333.333,0,0,1,.239.278l.187,1.467a.337.337,0,0,0,.329.3H8.747a.336.336,0,0,0,.329-.293l.187-1.469A.333.333,0,0,1,9.5,13.3a5.6,5.6,0,0,0,1.183-.491.333.333,0,0,1,.367.028l1.167.907a.328.328,0,0,0,.437-.023l1.057-1.057a.33.33,0,0,0,.026-.44l-.907-1.167a.333.333,0,0,1-.028-.367A5.6,5.6,0,0,0,13.293,9.5a.333.333,0,0,1,.278-.239l1.467-.187a.338.338,0,0,0,.3-.33V7.253a.336.336,0,0,0-.293-.329l-1.469-.187A.333.333,0,0,1,13.3,6.5a5.6,5.6,0,0,0-.5-1.182.332.332,0,0,1,.028-.367l.907-1.167a.327.327,0,0,0-.022-.436L12.659,2.29a.328.328,0,0,0-.44-.026l-1.167.907a.334.334,0,0,1-.367.028A5.572,5.572,0,0,0,9.5,2.708a.333.333,0,0,1-.239-.278L9.077.963a.338.338,0,0,0-.33-.3H7.253a.336.336,0,0,0-.329.293L6.737,2.429a.334.334,0,0,1-.239.279,5.571,5.571,0,0,0-1.183.49.334.334,0,0,1-.367-.027L3.782,2.263a.327.327,0,0,0-.436.022L2.289,3.343a.33.33,0,0,0-.026.44L3.17,4.949a.333.333,0,0,1,.028.367A5.561,5.561,0,0,0,2.707,6.5a.333.333,0,0,1-.278.239L.963,6.924a.337.337,0,0,0-.3.329V8.747a.336.336,0,0,0,.293.329l1.469.187A.333.333,0,0,1,2.7,9.5a5.6,5.6,0,0,0,.5,1.182.332.332,0,0,1-.028.367l-.907,1.167a.327.327,0,0,0,.022.436L3.341,13.71a.33.33,0,0,0,.44.026l1.167-.907a.343.343,0,0,1,.2-.069Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_20",
    "data-name": "Raggruppa 20",
    transform: "translate(4.667 4.667)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_20",
    "data-name": "Tracciato 20",
    d: "M10.333,13.667a3.333,3.333,0,1,1,3.333-3.333,3.333,3.333,0,0,1-3.333,3.333Zm0-6A2.667,2.667,0,1,0,13,10.333a2.667,2.667,0,0,0-2.667-2.666Z",
    transform: "translate(-7 -7)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.54ffef932b3a71ea7202b8d3d2a201fa.svg";
export { ForwardRef as ReactComponent };